type AppRow = {
    appId: string;
    raw?: {platform?: string} | null;
};

export function resolveAppPlatform(
    apps: Array<AppRow> | null | undefined,
    appId: string,
): string {
    const id = String(appId || '');
    if (!id) return '';
    const row = (apps || []).find((a) => a && String(a.appId) === id);
    return String(row?.raw?.platform || '')
        .toUpperCase()
        .trim();
}

export function platformDisplayLabel(platform: string): string {
    const p = String(platform || '')
        .toUpperCase()
        .trim();
    if (p === 'ANDROID') return 'Android';
    if (p === 'IOS') return 'iOS';
    return '';
}
